import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretRight = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M29.7455 22.5427C31.1512 21.137 31.1512 18.8542 29.7455 17.4486L15.3515 3.05456C14.3169 2.01999 12.7763 1.71637 11.4269 2.27863C10.0775 2.8409 9.20032 4.14536 9.20032 5.60725L9.20032 34.3952C9.20032 35.8459 10.0775 37.1616 11.4269 37.7239C12.7763 38.2861 14.3169 37.9713 15.3515 36.9479L29.7455 22.5539V22.5427Z" })
});
export default SvgCaretRight;
